import {Routes} from '@angular/router';
import {LayoutComponent} from './layout/components/layout/layout.component';
import {AclGuard} from '@shared/guards/acl.guard';
import {ExternalUriGuard} from '@shared/guards/external-uri.guard';
import {loggedOutGuard} from './auth/logged-out.guard';
import {loggedInGuard} from './auth/logged-in.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [loggedInGuard],
    canActivateChild: [AclGuard],
    children: [
      {
        path: 'binu',
        data: {acl: 'dashboard'},
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'product-structure',
        title: 'Product structure',
        data: {acl: 'can_edit_product_structure'},
        loadChildren: () => import('./product-structure/product-structure.routes').then(r => r.productStructureRoutes)
      },
      {
        path: 'procurement',
        title: 'Procurement',
        data: {acl: 'can_edit_manufacturing_procurement'},
        loadChildren: () => import('./procurement/procurement.module').then(m => m.ProcurementModule)
      },
      {
        path: 'outsourcing',
        title: 'Outsourcing',
        data: {acl: 'can_edit_outsourcing'},
        loadChildren: () => import('./outsourcing/outsourcing.module').then(m => m.OutsourcingModule)
      },
      {
        path: 'purchasing',
        title: 'Purchasing',
        data: {acl: 'can_edit_purchase'},
        loadChildren: () => import('./purchasing/purchasing.module').then(m => m.PurchasingModule)
      },
      {
        path: 'confirmation',
        title: 'Confirmation',
        data: {acl: 'can_edit_confirmation'},
        loadChildren: () => import('./confirmation/confirmation.routes').then(r => r.ConfirmationRoutes)
      },
      {
        path: 'warehouse',
        title: 'Warehouse',
        data: {acl: 'can_edit_warehouse'},
        loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule)
      },
      {
        path: 'sales',
        title: 'Sales',
        data: {acl: 'can_edit_sales'},
        loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule)
      },
      {
        path: 'manufacturing',
        title: 'Manufacturing',
        data: {acl: 'can_edit_manufacturing'},
        loadChildren: () => import('./manufacturing/manufacturing.module').then(m => m.ManufacturingModule)
      },
      {
        path: 'statistics',
        title: 'ERP Statistics',
        loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule)
      },
      {
        path: 'payments',
        title: 'Payments',
        data: {acl: 'can_edit_payments'},
        loadChildren: () => import('./payments/payments.routes').then(r => r.paymentsRoutes)
      },
      {
        path: 'administration',
        title: 'Administration',
        data: {acl: 'can_edit_administration'},
        loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)
      },
      {
        path: 'crm',
        title: 'CRM',
        data: {acl: 'can_edit_contacts_and_events'},
        loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
      },
      {
        path: 'business-trips',
        title: 'Business Trips',
        data: {acl: 'can_edit_business_trips'},
        loadChildren: () => import('./business-trips/business-trips.module').then(m => m.BusinessTripsModule)
      },
      {
        path: 'order-statuses-chart',
        loadComponent: () => import('./shared/components/order-statuses-chart/order-statuses-chart.component').then(c => c.OrderStatusesChartComponent)
      },
      {
        path: 'correspondence',
        data: {acl: 'can_edit_correspondents'},
        title: 'Correspondence',
        loadChildren: () => import('./correspondent/correspondent.routes').then(r => r.correspondentRoutes)
      },
      {
        path: 'instruments',
        title: 'Instruments',
        data: {acl: 'can_edit_instruments_and_tools'},
        loadChildren: () => import('./instruments/instruments.module').then(m => m.InstrumentsModule)
      },
      {
        path: 'quality-control',
        title: 'Quality Control',
        data: {acl: 'can_edit_quality_control'},
        loadChildren: () => import('./qc/qc.routes').then(r => r.QcRoutes)
      },
      {
        path: 'reports',
        title: 'Reports',
        data: {acl: 'can_edit_reports'},
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      }, {
        path: 'sales-billing',
        title: 'Sales Billing',
        data: {acl: 'can_edit_sales_billing'},
        loadChildren: () => import('./sales-billing/sales-billing.module').then(m => m.SalesBillingModule)
      },
      {path: '', redirectTo: 'binu', pathMatch: 'full'},
      {path: '**', redirectTo: 'dashboard'},
    ]
  },

  {
    path: 'auth',
    canActivate: [loggedOutGuard],
    loadChildren: () => import('./auth/auth.routes').then(r => r.AuthRoutes)
  },

  // Не удалять
  {path: 'external/:uri', canActivate: [ExternalUriGuard], children: []},
  {path: '', redirectTo: 'binu', pathMatch: 'full'},
  {path: '**', redirectTo: 'binu'},
];
